var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27 3a1 1 0 011 1v24a1 1 0 01-1 1H12a1 1 0 01-1-1v-9h2v8h13V5H13v8h-2V4a1 1 0 011-1zM16.798 9.983L22.814 16l-6.016 6.016-1.414-1.414L18.986 17H3v-2h15.986l-3.602-3.603 1.414-1.414z",
    fill: props.color
  })));
}

export default SvgIconLogin;